var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 289,
    viewBox: "0 0 307 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11071_11864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.047 30.679L184.518 23.5979L186.694 27.094C187.335 28.1228 188.503 28.68 189.714 28.5759C190.383 28.5184 191.057 28.4978 191.732 28.5119C192.945 28.538 194.072 27.9081 194.645 26.8457L196.598 23.2217L208.499 29.5732L206.546 33.1973C205.973 34.2608 206.07 35.5443 206.761 36.534C207.147 37.0858 207.502 37.6561 207.825 38.2425C208.408 39.3038 209.522 39.964 210.736 39.925L214.867 39.7949L215.286 53.2222L211.14 53.3469C209.925 53.3837 208.867 54.1241 208.347 55.2191C208.207 55.5161 208.058 55.811 207.9 56.1026C207.743 56.3942 207.578 56.6815 207.409 56.9622C206.782 57.9932 206.746 59.2735 207.383 60.2979L209.575 63.8201L198.104 70.9012L195.92 67.3986C195.278 66.3709 194.109 65.8147 192.898 65.9188C192.231 65.9763 191.56 65.999 190.888 65.9849C189.678 65.96 188.551 66.5899 187.979 67.6512L186.026 71.2763L174.126 64.9247L176.079 61.2996C176.651 60.2383 176.555 58.9558 175.865 57.965C175.481 57.4154 175.128 56.8473 174.808 56.2619C174.225 55.2006 173.113 54.5383 171.897 54.5751L167.757 54.702L167.338 41.2747L171.48 41.1468C172.692 41.1088 173.745 40.3706 174.263 39.2789C174.405 38.9808 174.555 38.6838 174.714 38.3889C174.871 38.0973 175.036 37.81 175.207 37.5292C175.836 36.4929 175.871 35.2061 175.231 34.1773L173.047 30.679ZM181.566 42.0487C178.681 47.404 180.701 54.0678 186.082 56.9406C191.463 59.8123 198.169 57.8067 201.056 52.4503C203.941 47.095 201.916 40.4161 196.535 37.5444C191.153 34.6716 184.452 36.6934 181.566 42.0487Z",
    fill: "#A8CCFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11071_11864)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.749,
    cy: 270.914,
    rx: 45.7807,
    ry: 5.92456,
    fill: "#D6E8FF",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.70881 46.4803L17.1802 39.3991L19.3566 42.8952C19.9971 43.924 21.1649 44.4812 22.3762 44.3772C23.045 44.3197 23.7193 44.2991 24.3946 44.3132C25.607 44.3392 26.7344 43.7094 27.3074 42.647L29.2605 39.0229L41.1611 45.3745L39.208 48.9986C38.635 50.062 38.732 51.3456 39.4237 52.3353C39.8093 52.8871 40.1644 53.4573 40.4868 54.0438C41.0707 55.1051 42.1839 55.7653 43.3985 55.7263L47.5291 55.5962L47.9485 69.0235L43.8026 69.1481C42.587 69.185 41.5293 69.9254 41.0097 71.0203C40.8692 71.3174 40.7199 71.6122 40.562 71.9038C40.4051 72.1955 40.2406 72.4827 40.0707 72.7635C39.4444 73.7945 39.4084 75.0747 40.0456 76.0992L42.2373 79.6213L30.7659 86.7025L28.5819 83.1998C27.9403 82.1721 26.7715 81.616 25.5602 81.7201C24.8935 81.7775 24.2225 81.8003 23.5504 81.7862C22.3402 81.7613 21.2128 82.3911 20.6409 83.4524L18.6878 87.0776L6.7883 80.726L8.74144 77.1009C9.31332 76.0396 9.21744 74.7571 8.52683 73.7663C8.14339 73.2167 7.79046 72.6486 7.47021 72.0632C6.88744 71.0019 5.77526 70.3395 4.55961 70.3764L0.419197 70.5032L-0.000190735 57.0759L4.14241 56.948C5.35371 56.9101 6.40705 56.1718 6.92556 55.0802C7.06717 54.7821 7.21749 54.485 7.37653 54.1902C7.53339 53.8985 7.69787 53.6113 7.86889 53.3305C8.4985 52.2941 8.53336 51.0073 7.89286 49.9786L5.70881 46.4803ZM14.2282 57.85C11.3427 63.2053 13.3633 69.869 18.7444 72.7418C24.1256 75.6135 30.8313 73.608 33.7179 68.2516C36.6035 62.8963 34.5785 56.2174 29.1973 53.3457C23.8151 50.4729 17.1138 52.4947 14.2282 57.85Z",
    fill: "#A8CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.926 98.929L226.24 94.4142L227.628 96.6432C228.036 97.2992 228.781 97.6544 229.553 97.5881C229.979 97.5514 230.409 97.5383 230.84 97.5473C231.613 97.5639 232.332 97.1623 232.697 96.4849L233.942 94.1743L241.53 98.224L240.285 100.535C239.919 101.213 239.981 102.031 240.422 102.662C240.668 103.014 240.894 103.377 241.1 103.751C241.472 104.428 242.182 104.849 242.956 104.824L245.59 104.741L245.857 113.302L243.214 113.382C242.439 113.405 241.765 113.877 241.433 114.575C241.344 114.765 241.249 114.953 241.148 115.139C241.048 115.325 240.943 115.508 240.835 115.687C240.435 116.344 240.412 117.16 240.819 117.814L242.216 120.059L234.902 124.574L233.51 122.341C233.101 121.686 232.355 121.331 231.583 121.397C231.158 121.434 230.73 121.448 230.302 121.439C229.53 121.424 228.811 121.825 228.447 122.502L227.201 124.813L219.614 120.764L220.86 118.452C221.224 117.776 221.163 116.958 220.723 116.326C220.478 115.976 220.253 115.613 220.049 115.24C219.678 114.564 218.969 114.141 218.193 114.165L215.554 114.246L215.286 105.685L217.927 105.603C218.7 105.579 219.371 105.108 219.702 104.412C219.792 104.222 219.888 104.033 219.989 103.845C220.089 103.659 220.194 103.476 220.303 103.297C220.705 102.636 220.727 101.815 220.319 101.159L218.926 98.929ZM224.358 106.178C222.518 109.593 223.807 113.841 227.237 115.673C230.668 117.504 234.944 116.225 236.784 112.81C238.624 109.396 237.333 105.137 233.902 103.306C230.47 101.475 226.198 102.764 224.358 106.178Z",
    fill: "#A8CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0308 0H187.418V72.7476H99.0308V0Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6957 73.0835H187.752L187.417 0H99.0299L98.6957 73.0835Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0308 0H187.418V6.40778H99.0308V0Z",
    fill: "#066CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.416 3.24881C181.416 4.14001 182.136 4.86186 183.025 4.86186C183.914 4.86186 184.635 4.14001 184.635 3.24881C184.635 2.35855 183.915 1.63574 183.025 1.63574C182.136 1.63669 181.416 2.35855 181.416 3.24881Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.845 3.24881C174.845 4.14001 175.565 4.86186 176.454 4.86186C177.342 4.86186 178.064 4.14001 178.064 3.24881C178.064 2.35855 177.343 1.63574 176.454 1.63574C175.566 1.63669 174.845 2.35855 174.845 3.24881Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.274 3.24881C168.274 4.14001 168.995 4.86186 169.884 4.86186C170.772 4.86186 171.493 4.14001 171.493 3.24881C171.493 2.35855 170.773 1.63574 169.884 1.63574C168.995 1.63669 168.274 2.35855 168.274 3.24881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.141 19.1541H180.559V20.4057H177.141V19.1541Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.439 19.1541H174.649V20.4057H135.439V19.1541Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.846 19.1541H133.339V20.4057H126.846V19.1541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.995 35.8984H118.488V37.1501H111.995V35.8984Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.21 19.1541H125.434V20.4057H114.21V19.1541Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.722 22.5039H177.14V23.7556H173.722V22.5039Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.585 22.5039H171.317V23.7556H145.585V22.5039Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.031 35.8984H135.097V37.1501H120.031V35.8984Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.071 32.551H174.649V33.8027H150.071V32.551Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.075 25.8523H171.317V27.104H154.075V25.8523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.421 29.2026H128.997V30.4543H122.421V29.2026Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.627 25.8523H152.161V27.104H124.627V25.8523Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.781 35.8984H174.649V37.1501H141.781V35.8984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.346 22.5039H126.158V23.7556H108.346V22.5039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.571 22.5039H143.97V23.7556H127.571V22.5039Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.265 25.8523H123.332V27.104H112.265V25.8523Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.722 25.8523H177.14V27.104H173.722V25.8523Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.141 29.2026H180.559V30.4543H177.141V29.2026Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.448 29.2026H174.649V30.4543H154.448V29.2026Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.115 39.2483H171.318V40.4999H151.115V39.2483Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.289 42.5972H133.647V43.8488H118.289V42.5972Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.216 39.2483H149.475V40.4999H129.216V39.2483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.414 42.5972H153.048V43.8488H135.414V42.5972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.447 43.8602L163.94 43.8488V42.5972L154.447 42.6085V43.8602Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.468 42.5972H171.317V43.8488H165.468V42.5972Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.846 32.551H148.68V33.8027H126.846V32.551Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.541 32.551H125.434V33.8027H111.541V32.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.586 29.2026H152.394V30.4543H130.586V29.2026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.141 32.551H180.559V33.8027H177.141V32.551Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.141 35.8984H180.559V37.1501H177.141V35.8984Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.722 39.2483H177.14V40.4999H173.722V39.2483Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.722 42.5972H177.14V43.8488H173.722V42.5972Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.141 45.4021H180.559V46.6538H177.141V45.4021Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.731 45.4021H174.649V46.6538H150.731V45.4021Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.722 48.752H177.14V50.0036H173.722V48.752Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.585 48.752H171.317V50.0036H145.585V48.752Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.071 58.7976H174.649V60.0493H150.071V58.7976Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.075 52.0999H171.317V53.3515H154.075V52.0999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.627 52.0999H152.161V53.3515H124.627V52.0999Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.781 62.1465H174.649V63.3981H141.781V62.1465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.346 48.752H126.158V50.0036H108.346V48.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.571 48.752H143.97V50.0036H127.571V48.752Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.265 52.0999H123.332V53.3515H112.265V52.0999Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.722 52.0999H177.14V53.3515H173.722V52.0999Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.141 55.4487H180.559V56.7004H177.141V55.4487Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.448 55.4487H174.649V56.7004H154.448V55.4487Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.846 58.7976H148.68V60.0493H126.846V58.7976Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.586 55.4487H152.394V56.7004H130.586V55.4487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.141 58.7976H180.559V60.0493H177.141V58.7976Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.447 15.8593C178.329 15.9814 178.329 16.1649 178.447 16.2822C178.508 16.339 178.578 16.3664 178.653 16.3664C178.733 16.3664 178.808 16.338 178.869 16.2822L180.187 14.9416C180.201 14.9369 180.206 14.9274 180.21 14.9132C180.215 14.9085 180.225 14.9038 180.225 14.9038C180.234 14.8896 180.234 14.8801 180.239 14.8659C180.248 14.8612 180.253 14.8517 180.253 14.847C180.258 14.8376 180.258 14.8234 180.262 14.8186C180.262 14.8044 180.272 14.7997 180.272 14.795C180.272 14.7808 180.272 14.7713 180.272 14.7619C180.272 14.7524 180.277 14.7477 180.277 14.7335C180.277 14.7288 180.272 14.7146 180.272 14.7098C180.272 14.7004 180.272 14.6862 180.272 14.6767C180.272 14.6673 180.262 14.6625 180.262 14.6578C180.258 14.6436 180.258 14.6341 180.253 14.62C180.253 14.6152 180.248 14.6152 180.248 14.6105C180.239 14.5963 180.234 14.5774 180.225 14.5679C180.225 14.5679 180.225 14.5585 180.215 14.5585C180.21 14.549 180.201 14.5348 180.187 14.5253L178.869 13.1848C178.752 13.0712 178.559 13.0712 178.447 13.1848C178.329 13.3021 178.329 13.4903 178.447 13.6077L179.559 14.7316L178.447 15.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.252 16.01L176.103 13.2682C176.046 13.1367 175.897 13.0752 175.761 13.132C175.634 13.1831 175.573 13.3392 175.63 13.466L176.779 16.2124C176.822 16.3108 176.92 16.3676 177.019 16.3676C177.047 16.3676 177.084 16.3628 177.113 16.3487C177.248 16.2966 177.309 16.1415 177.252 16.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.359 14.9039C173.359 14.9039 173.359 14.9086 173.363 14.9086C173.373 14.9181 173.382 14.9323 173.396 14.9417L174.715 16.2823C174.771 16.3391 174.851 16.3665 174.927 16.3665C175.007 16.3665 175.077 16.3381 175.137 16.2823C175.255 16.165 175.255 15.9815 175.137 15.8594L174.026 14.7355L175.137 13.6116C175.255 13.4942 175.255 13.306 175.137 13.1887C175.025 13.0751 174.832 13.0751 174.715 13.1887L173.396 14.5293C173.382 14.5387 173.373 14.5529 173.363 14.5624C173.359 14.5624 173.359 14.5718 173.359 14.5718C173.349 14.5907 173.341 14.6002 173.335 14.6144C173.335 14.6191 173.33 14.6191 173.33 14.6239C173.326 14.6381 173.325 14.6475 173.316 14.6664C173.316 14.6712 173.311 14.6712 173.311 14.6806C173.311 14.6901 173.311 14.7043 173.311 14.7137C173.311 14.7185 173.306 14.7327 173.306 14.7374C173.306 14.7421 173.311 14.7563 173.311 14.761C173.311 14.7752 173.311 14.7847 173.311 14.7989C173.311 14.8036 173.316 14.8036 173.316 14.8083C173.325 14.8273 173.326 14.8415 173.33 14.8509C173.33 14.8556 173.335 14.8556 173.335 14.8651C173.341 14.8708 173.349 14.885 173.359 14.9039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0539 55.6084H125.321V128.357H18.0539V55.6084Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7189 128.692H125.655L125.32 55.6084H18.0531L17.7189 128.692Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0539 55.6084H125.321V62.0162H18.0539V55.6084Z",
    fill: "#066CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.318 58.8582C119.318 59.7484 120.039 60.4712 120.928 60.4712C121.816 60.4712 122.537 59.7494 122.537 58.8582C122.537 57.967 121.817 57.2451 120.928 57.2451C120.04 57.2461 119.318 57.9679 119.318 58.8582Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.357 60.4712C113.468 60.4712 112.747 59.749 112.747 58.8582C112.747 57.9673 113.468 57.2451 114.357 57.2451C115.246 57.2451 115.966 57.9673 115.966 58.8582C115.966 59.749 115.246 60.4712 114.357 60.4712Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.177 58.8582C106.177 59.7484 106.897 60.4712 107.787 60.4712C108.675 60.4712 109.396 59.7494 109.396 58.8582C109.396 57.967 108.676 57.2451 107.787 57.2451C106.897 57.2461 106.177 57.9679 106.177 58.8582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.044 74.7625H118.462V76.0141H115.044V74.7625Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2215 74.7625H112.552V76.0141H92.2215V74.7625Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9064 74.7625H42.308V76.0141H33.9064V74.7625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6295 74.7625H90.1223V76.0141H83.6295V74.7625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9526 74.7625H69.0222V76.0141H43.9526V74.7625Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5535 91.5085H56.3914V92.7593H36.5535V91.5085Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9929 74.7625H82.217V76.0141H70.9929V74.7625Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.625 78.1113H115.043V79.363H111.625V78.1113Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4881 78.1113H109.22V79.363H83.4881V78.1113Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9337 91.5085H72.9998V92.7593H57.9337V91.5085Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9744 88.158H112.552V89.4096H87.9744V88.158Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9784 81.4602H109.22V82.7119H91.9784V81.4602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3929 81.4602H48.6349V82.7119H31.3929V81.4602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3236 84.8103H66.9004V86.062H60.3236V84.8103Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5301 81.4602H90.0645V82.7119H62.5301V81.4602Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6843 91.5085H112.552V92.7593H79.6843V91.5085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4426 78.1113H74.2548V79.363H56.4426V78.1113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6669 78.1113H81.8727V79.363H75.6669V78.1113Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.492 78.1113H54.4045V79.363H28.492V78.1113Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1689 81.4602H61.2354V82.7119H50.1689V81.4602Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.625 81.4602H115.043V82.7119H111.625V81.4602Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.044 84.8103H118.462V86.062H115.044V84.8103Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3508 84.8103H112.552V86.062H92.3508V84.8103Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9067 84.8103H59.1081V86.062H38.9067V84.8103Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.018 94.8557H109.22V96.1074H89.018V94.8557Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3203 98.2041H80.679V99.4558H65.3203V98.2041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1186 94.8557H87.3776V96.1074H67.1186V94.8557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1604 98.2041H100.795V99.4558H83.1604V98.2041Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.371 98.2041H109.22V99.4558H103.371V98.2041Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4457 98.2041H63.7453V99.4558H49.4457V98.2041Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7496 88.158H86.5841V89.4096H64.7496V88.158Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4445 88.158H63.3372V89.4096H49.4445V88.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4888 84.8103H90.2969V86.062H68.4888V84.8103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.044 88.158H118.462V89.4096H115.044V88.158Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.044 91.5085H118.462V92.7593H115.044V91.5085Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.625 94.8557H115.043V96.1074H111.625V94.8557Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8202 94.8557H65.4539V96.1074H44.8202V94.8557Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.625 98.2041H115.043V99.4558H111.625V98.2041Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.044 101.01H118.462V102.261H115.044V101.01Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3416 101.01H112.552V102.261H73.3416V101.01Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.625 104.359H115.043V105.611H111.625V104.359Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4881 104.359H109.22V105.611H83.4881V104.359Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9744 114.406H112.552V115.658H87.9744V114.406Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9784 107.708H109.22V108.96H91.9784V107.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5301 107.708H90.0645V108.96H62.5301V107.708Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6843 117.756H112.552V119.008H79.6843V117.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.249 104.359H64.0612V105.611H46.249V104.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4737 104.359H81.8727V105.611H65.4737V104.359Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1689 107.708H61.2354V108.96H50.1689V107.708Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.625 107.708H115.043V108.96H111.625V107.708Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.044 111.057H118.462V112.309H115.044V111.057Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7143 111.057H67.0303V112.309H53.7143V111.057Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3508 111.057H112.552V112.309H92.3508V111.057Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.368 111.057H51.6072V112.309H40.368V111.057Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7496 114.406H86.5841V115.658H64.7496V114.406Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4886 111.057H90.2967V112.309H68.4886V111.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.044 114.406H118.462V115.658H115.044V114.406Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.351 71.4675C116.233 71.5895 116.233 71.7731 116.351 71.8904C116.411 71.9472 116.482 71.9746 116.557 71.9746C116.637 71.9746 116.712 71.9462 116.773 71.8904L118.091 70.5498C118.105 70.5451 118.11 70.5356 118.114 70.5214C118.119 70.5167 118.128 70.512 118.128 70.512C118.138 70.4978 118.138 70.4883 118.143 70.4741C118.152 70.4694 118.157 70.4599 118.157 70.4552C118.161 70.4457 118.161 70.4315 118.166 70.4268C118.166 70.4126 118.176 70.4079 118.176 70.4032C118.176 70.389 118.176 70.3795 118.176 70.37C118.176 70.3606 118.18 70.3559 118.18 70.3417C118.18 70.3369 118.176 70.3227 118.176 70.318C118.176 70.3085 118.176 70.2944 118.176 70.2849C118.176 70.2754 118.166 70.2707 118.166 70.266C118.161 70.2518 118.161 70.2423 118.157 70.2281C118.157 70.2234 118.152 70.2234 118.152 70.2187C118.143 70.2045 118.138 70.1856 118.128 70.1761C118.128 70.1761 118.128 70.1666 118.119 70.1666C118.114 70.1572 118.105 70.143 118.091 70.1335L116.773 68.7929C116.656 68.6804 116.463 68.6804 116.351 68.7929C116.233 68.9102 116.233 69.0985 116.351 69.2158L117.462 70.3398L116.351 71.4675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.156 71.6174L114.006 68.8757C113.949 68.7442 113.8 68.6827 113.664 68.7394C113.538 68.7905 113.476 68.9466 113.533 69.0734L114.683 71.8198C114.725 71.9182 114.823 71.975 114.922 71.975C114.951 71.975 114.988 71.9703 115.016 71.9561C115.151 71.904 115.211 71.7489 115.156 71.6174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.262 70.5128C111.262 70.5128 111.262 70.5175 111.267 70.5175C111.276 70.527 111.285 70.5412 111.3 70.5506L112.618 71.8912C112.674 71.948 112.754 71.9754 112.83 71.9754C112.91 71.9754 112.98 71.9471 113.04 71.8912C113.158 71.7739 113.158 71.5904 113.04 71.4683L111.929 70.3444L113.04 69.2205C113.158 69.1032 113.158 68.9149 113.04 68.7976C112.928 68.685 112.735 68.685 112.618 68.7976L111.3 70.1382C111.285 70.1476 111.276 70.1618 111.267 70.1713C111.262 70.1713 111.262 70.1807 111.262 70.1807C111.252 70.1997 111.244 70.2091 111.238 70.2233C111.238 70.228 111.234 70.228 111.234 70.2328C111.229 70.247 111.229 70.2564 111.219 70.2753C111.219 70.2801 111.215 70.2801 111.215 70.2895C111.215 70.299 111.215 70.3132 111.215 70.3226C111.215 70.3274 111.21 70.3416 111.21 70.3463C111.21 70.351 111.215 70.3652 111.215 70.3699C111.215 70.3841 111.215 70.3936 111.215 70.4078C111.215 70.4125 111.219 70.4125 111.219 70.4173C111.229 70.4362 111.229 70.4504 111.234 70.4598C111.234 70.4646 111.238 70.4646 111.238 70.474C111.244 70.4797 111.253 70.4939 111.262 70.5128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.443 112.782H157.334V79.3635H156.39V111.836H136.443V112.782Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.269 115.139L132.379 112.309L137.269 109.479V115.139Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11071_11864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.335 208.526C197.843 212.64 197.965 216.931 198.621 221.131C210.695 234.592 231.864 236.713 249.209 227.211C250.836 223.286 251.958 219.144 252.449 215.041C254.616 196.921 242.86 192.49 227.91 190.69C212.96 188.891 200.502 190.406 198.335 208.526Z",
    fill: "url(#paint0_linear_11071_11864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.621 221.131C200.852 235.441 209.271 248.671 220.818 250.061C232.365 251.451 243.677 240.587 249.209 227.211C248.626 227.12 248.036 226.997 247.459 226.844C243.09 225.703 230.968 224.478 228.353 220.794C226.656 218.41 225.515 215.654 223.738 213.333C223.72 213.31 223.711 213.298 223.693 213.275C220.7 209.43 215.128 208.759 211.313 211.785C211.29 211.803 211.279 211.812 211.256 211.83C208.971 213.662 207.213 216.069 205.012 217.984C201.602 220.943 197.143 222.649 200.82 221.229C200.078 221.244 199.342 221.208 198.611 221.13L198.621 221.131Z",
    fill: "url(#paint1_linear_11071_11864)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M226.846 198.626C216.284 197.355 207.909 194.759 208.14 192.827C208.371 190.896 217.12 190.362 227.682 191.633C238.245 192.905 246.62 195.501 246.389 197.432C246.158 199.363 237.408 199.898 226.846 198.626Z",
    fill: "url(#paint2_radial_11071_11864)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11071_11864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.53 199.256C180.143 197.032 167.477 202.478 162.444 205.035C156.986 207.804 155.985 212.542 163.774 215.794C169.786 218.296 177.15 219.756 184.13 219.96C190.251 220.135 196.562 219.003 201.443 215.944C202.672 215.177 203.627 214.121 204.235 212.888C205.798 209.746 204.828 205.958 201.855 203.588C199.208 201.484 195.943 199.875 192.517 199.262L192.53 199.256Z",
    fill: "url(#paint3_linear_11071_11864)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.538 153.647C167.227 152.767 162.05 145.821 162.969 138.139C163.888 130.457 170.556 124.938 177.867 125.818L174.539 153.636L174.538 153.647Z",
    fill: "url(#paint4_linear_11071_11864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.339 142.032C168.86 171.115 194.712 181.613 227.666 185.581C260.62 189.548 288.213 185.484 291.692 156.401L292.344 150.951C295.823 121.868 269.972 111.369 237.018 107.402C204.064 103.435 176.47 107.499 172.991 136.582L172.339 142.032Z",
    fill: "url(#paint5_linear_11071_11864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.649 169.087C291.959 169.967 298.627 164.448 299.546 156.766C300.465 149.084 295.288 142.139 287.978 141.258C287.978 141.258 284.639 148.031 283.996 154.804C283.353 161.577 284.65 169.076 284.65 169.076L284.649 169.087Z",
    fill: "url(#paint6_linear_11071_11864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.868 108.696C204.475 111.68 206.025 115.531 206.48 120.339C206.622 121.862 207.854 123.055 209.399 123.197L245.204 126.505C246.739 126.647 248.177 125.691 248.591 124.23C249.898 119.584 252.129 116.082 255.231 113.626C251.171 115.531 248.75 117.249 247.521 121.604C247.136 122.986 245.787 123.878 244.344 123.745L210.754 120.642C209.312 120.508 208.157 119.385 208.017 117.954C207.597 113.447 205.53 110.247 201.879 108.697L201.868 108.696Z",
    fill: "#066CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.679 148.312C174.75 164.437 195.519 171.038 221.728 174.193C247.937 177.348 269.673 175.865 271.602 159.74L271.964 156.717C273.893 140.591 253.123 133.991 226.915 130.836C200.706 127.681 178.97 129.163 177.041 145.289L176.679 148.312Z",
    fill: "url(#paint7_linear_11071_11864)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M177.04 145.288L176.679 148.312C176.657 148.497 176.636 148.672 176.615 148.847C178.954 133.219 200.494 131.807 226.415 134.927C252.336 138.048 272.931 144.533 271.518 160.272C271.538 160.097 271.561 159.912 271.581 159.737L271.943 156.714C273.872 140.589 253.103 133.988 226.894 130.833C200.685 127.678 178.949 129.161 177.02 145.286L177.04 145.288Z",
    fill: "#131E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.617 157.774C230.193 158.881 231.118 160.036 232.285 159.874C234.99 159.5 237.714 159.484 240.397 159.807C243.081 160.13 245.724 160.793 248.263 161.797C249.369 162.233 250.531 161.33 250.379 160.153C249.775 155.616 246.175 151.876 241.415 151.302C236.654 150.729 232.275 153.509 230.617 157.774Z",
    fill: "#066CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.902 154.679C205.054 155.855 203.882 156.757 202.787 156.323C200.247 155.318 197.604 154.656 194.92 154.333C192.237 154.01 189.513 154.026 186.808 154.399C185.631 154.56 184.716 153.407 185.14 152.3C186.798 148.035 191.177 145.255 195.938 145.828C200.698 146.401 204.298 150.141 204.902 154.679Z",
    fill: "#066CFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_11071_11864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.527 199.26C208.14 197.036 195.474 202.482 190.441 205.039C184.983 207.807 183.982 212.546 191.771 215.798C197.782 218.3 205.147 219.76 212.127 219.964C218.248 220.139 224.559 219.007 229.44 215.948C230.669 215.181 231.624 214.125 232.232 212.892C233.795 209.75 232.825 205.961 229.852 203.592C227.205 201.488 223.94 199.878 220.514 199.266L220.527 199.26Z",
    fill: "url(#paint8_linear_11071_11864)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M118.517 216.263H229.547V221.254H118.517V216.263Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.518 216.263H174.4V221.254H118.518V216.263Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.387 221.249H60.1817L46.0336 147.597H154.24L168.387 221.249Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.797 184.424C114.115 188.069 111.425 191.024 107.787 191.024C104.149 191.024 100.942 188.068 100.624 184.424C100.306 180.778 102.997 177.823 106.634 177.823C110.272 177.823 113.479 180.778 113.797 184.424Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1012 194.798L60.1834 221.245H144.091L55.1012 194.798Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11071_11864",
    x: 172.351,
    y: 256.372,
    width: 108.796,
    height: 29.0842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.30877,
    result: "effect1_foregroundBlur_11071_11864"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11071_11864",
    x: 147.989,
    y: 189.71,
    width: 56.9865,
    height: 30.2669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.64,
    dy: -4.512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.256
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.423529 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11071_11864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11071_11864",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11071_11864",
    x: 175.986,
    y: 189.714,
    width: 56.9865,
    height: 30.2669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.64,
    dy: -4.512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.256
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.423529 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11071_11864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11071_11864",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11071_11864",
    x1: 224.51,
    y1: 219.199,
    x2: 227.204,
    y2: 196.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11071_11864",
    x1: 222.349,
    y1: 237.268,
    x2: 225.528,
    y2: 210.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_11071_11864",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.666 200.128) rotate(-173.135) scale(18.3927 3.67889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11071_11864",
    x1: 180.05,
    y1: 215.654,
    x2: 183.625,
    y2: 200.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11071_11864",
    x1: 176.202,
    y1: 139.733,
    x2: 162.968,
    y2: 138.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11071_11864",
    x1: 292.018,
    y1: 153.676,
    x2: 172.654,
    y2: 139.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11071_11864",
    x1: 299.546,
    y1: 156.766,
    x2: 286.312,
    y2: 155.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11071_11864",
    x1: 226.33,
    y1: 135.721,
    x2: 222.016,
    y2: 171.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11071_11864",
    x1: 208.047,
    y1: 215.658,
    x2: 211.622,
    y2: 200.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D4FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11071_11864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 307,
    height: 288.688,
    fill: "white",
    transform: "matrix(-1 0 0 1 307 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11071_11864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.761,
    height: 144.049,
    fill: "white",
    transform: "matrix(-0.992831 -0.119528 -0.118777 0.992921 307 115.497)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotLeft);
export default __webpack_public_path__ + "static/media/Robot_left.5a9b307ebb9999dc0f7faf451b677091.svg";
export { ForwardRef as ReactComponent };